<template>
  <div
    class="card-on-card card-outline-secondary"
    id="priceLayout"
    v-if="isLayoutBook === true"
  >
    <div class="card-header">
      <h5 class="mb-2 font-weight-bold">Informasi Harga</h5>
    </div>
    <div class="card-body">
      <div class="row p-2">
        <div class="col-md-4">
          <div class="form-group">
            <label class="">Harga Normal</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <label class="input-group-text">Rp.</label>
              </div>
              <CurrencyInput
                ref="harga_normal"
                :value="sectionPriceInformation.price"
                name="harga_normal"
                class="form-control col-md"
                id="hargaSatuan"
              />
              <div class="invalid-feedback invalidHargaNormal"></div>
            </div>
          </div>

          <div class="form-group">
            <label>Stok</label>
            <CurrencyInput
              v-model="sectionPriceInformation.stock"
              class="form-control"
              id="productStock"
              @keyup="validateNotNull('productStock')"
            />
            <div class="invalid-feedback invalidStock"></div>
          </div>

          <div class="form-group">
            <label class="mr-3 col-md-3">PPN 10%</label>
            <select name="" class="form-control col-md" id="productPpn">
              <option
                :value="ppn.value"
                v-for="ppn in sectionPriceInformation.ppn"
                :key="ppn.id"
                :selected="ppn.isSelected"
              >
                {{ ppn.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-4">
          <div
            v-for="(zone, index) in sectionPriceInformation.priceZone"
            :key="index"
            class="form-group"
          >
            <label>Harga Zona {{ index + 1 }}</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <label class="input-group-text">Rp.</label>
              </div>
              <CurrencyInput
                :value="Number(zone.price)"
                class="form-control col-md"
                :id="'harga_zona' + (index + 1)"
                :name="'harga_zona' + (index + 1)"
                @keyup="
                  autoCorrectPrice(
                    'harga_zona' + (index + 1),
                    'maksZone' + (index + 1)
                  )
                "
              />
              <div :class="'invalid-feedback harga_zona' + (index + 1)">
                Harga tidak boleh melewati harga maksimal zona {{ index + 1 }}
              </div>
              <div class="invalid-feedback invalidzone2"></div>
            </div>
          </div>
        </div>
        <!-- Harga maks zone -->
        <div class="col-md-4">
          <div
            v-for="(zone, index) in sectionPriceInformation.priceZone"
            :key="index"
            class="form-group"
          >
            <label>Maks Harga Zona {{ index + 1 }}</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <label class="input-group-text">Rp.</label>
              </div>
              <CurrencyInput
                disabled
                :value="Number(zone.price)"
                class="form-control col-md"
                :id="'maksZone' + (index + 1)"
                :name="'maksZone' + (index + 1)"
              />
              <div class="invalid-feedback invalidzone2"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-header">
      <h5 class="mb-2">
        <b>Harga Grosir</b>
        <button
          class="ml-2 btn btn-info btn-circle btn-sm collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#grosirCollapse"
          aria-expanded="false"
          aria-controls="grosirCollapse"
        >
          <i
            class="fa fa-compress"
            style="font-size: 12px"
            aria-hidden="true"
          ></i>
        </button>
      </h5>
      <p class="grosir-info">
        Masukkan harga grosir. Harga grosir biasanya lebih murah daripada harga
        satuan. Harga grosir memiliki minimum pembelian dan harga bertingkat
        (3-4 tingkat). Barang seperti ini disebut juga barang Wholesale.
      </p>
    </div>
    <div class="card-body collapse" id="grosirCollapse" style="">
      <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active"
            id="pills-home-tab"
            data-toggle="pill"
            href="#grosirZone1"
            role="tab"
            aria-controls="pills-home"
            aria-selected="true"
            ><span style="font-size: 12px">Grosir Zona 1</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="pills-profile-tab"
            data-toggle="pill"
            href="#grosirZone2"
            role="tab"
            aria-controls="pills-profile"
            aria-selected="false"
            ><span style="font-size: 12px">Grosir Zona 2</span></a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="pills-profile-tab"
            data-toggle="pill"
            href="#grosirZone3"
            role="tab"
            aria-controls="pills-profile"
            aria-selected="false"
            ><span style="font-size: 12px">Grosir Zona 3</span></a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="pills-profile-tab"
            data-toggle="pill"
            href="#grosirZone4"
            role="tab"
            aria-controls="pills-profile"
            aria-selected="false"
            ><span style="font-size: 12px">Grosir Zona 4</span></a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            id="pills-profile-tab"
            data-toggle="pill"
            href="#grosirZone5"
            role="tab"
            aria-controls="pills-profile"
            aria-selected="false"
            ><span style="font-size: 12px">Grosir Zona 5</span></a
          >
        </li>
      </ul>

      <div class="tab-content" id="pills-tabContent">
        <template v-if="isLayoutBook && !isLayoutService">
          <div
            class="tab-pane fade show active"
            id="grosirZone1"
            role="tabpanel"
            aria-labelledby="grosirZone5-tab"
          >
            <div class="row">
              <div class="col-12">
                <div
                  class="form-row"
                  v-for="(z1, index) in bookPriceGrosir.zone1"
                  :key="index"
                >
                  <div class="col-md-2">
                    <div class="form-group">
                      <div class="form-group">
                        <label>Pembelian Minimum</label>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <label class="input-group-text">Min.</label>
                          </div>
                          <input
                            class="form-control"
                            type="number"
                            :value="Number(z1.min)"
                            min="0"
                            max="999999999999"
                            maxlength="20"
                            oninput="this.value=this.value.slice(0,this.maxLength||1/1);
                                this.value=(this.value   < 0) ? (1/1) : this.value;"
                            :name="'bookMinWholesaleZone1Part' + (index + 1)"
                            :id="'bookMinWholesaleZone1Part' + (index + 1)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="form-group">
                      <label class="text-success"
                        >Harga Grosir {{ index + 1 }}</label
                      >
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <label class="input-group-text">Rp.</label>
                        </div>
                        <CurrencyInput
                          :value="Number(z1.price)"
                          @keyup="
                            validateNotNullPrice(
                              'bookWholesalePriceZone1Part' + (index + 1),
                              Number(z1.price)
                            )
                          "
                          class="form-control"
                          :name="'bookWholesalePriceZone1Part' + (index + 1)"
                          :id="'bookWholesalePriceZone1Part' + (index + 1)"
                        />
                        <div
                          :class="
                            `invalid-feedback invalidbookWholesalePriceZone1Part${index +
                              1}`
                          "
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade show"
            id="grosirZone2"
            role="tabpanel"
            aria-labelledby="grosirZone5-tab"
          >
            <div class="row">
              <div class="col-12">
                <div
                  class="form-row"
                  v-for="(z2, index) in bookPriceGrosir.zone2"
                  :key="index"
                >
                  <div class="col-md-2">
                    <div class="form-group">
                      <div class="form-group">
                        <label>Pembelian Minimum</label>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <label class="input-group-text">Min.</label>
                          </div>
                          <input
                            class="form-control"
                            type="number"
                            :value="Number(z2.min)"
                            min="0"
                            max="999999999999"
                            maxlength="20"
                            oninput="this.value=this.value.slice(0,this.maxLength||1/1);
                                this.value=(this.value   < 0) ? (1/1) : this.value;"
                            :name="'bookMinWholesaleZone2Part' + (index + 1)"
                            :id="'bookMinWholesaleZone2Part' + (index + 1)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="form-group">
                      <label class="text-success"
                        >Harga Grosir {{ index + 1 }}</label
                      >
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <label class="input-group-text">Rp.</label>
                        </div>
                        <CurrencyInput
                          :value="Number(z2.price)"
                          @keyup="
                            validateNotNullPrice(
                              'bookWholesalePriceZone2Part' + (index + 1),
                              Number(z2.price)
                            )
                          "
                          class="form-control"
                          :name="'bookWholesalePriceZone2Part' + (index + 1)"
                          :id="'bookWholesalePriceZone2Part' + (index + 1)"
                        />
                        <div
                          :class="
                            `invalid-feedback invalidbookWholesalePriceZone2Part${index +
                              1}`
                          "
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade show"
            id="grosirZone3"
            role="tabpanel"
            aria-labelledby="grosirZone5-tab"
          >
            <div class="row">
              <div class="col-12">
                <div
                  class="form-row"
                  v-for="(z3, index) in bookPriceGrosir.zone3"
                  :key="index"
                >
                  <div class="col-md-2">
                    <div class="form-group">
                      <div class="form-group">
                        <label>Pembelian Minimum</label>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <label class="input-group-text">Min.</label>
                          </div>
                          <input
                            min="0"
                            max="999999999999"
                            maxlength="20"
                            oninput="this.value=this.value.slice(0,this.maxLength||1/1);
                                this.value=(this.value   < 0) ? (1/1) : this.value;"
                            class="form-control"
                            type="number"
                            :value="Number(z3.min)"
                            :name="'bookMinWholesaleZone3Part' + (index + 1)"
                            :id="'bookMinWholesaleZone3Part' + (index + 1)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="form-group">
                      <label class="text-success"
                        >Harga Grosir {{ index + 1 }}</label
                      >
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <label class="input-group-text">Rp.</label>
                        </div>
                        <CurrencyInput
                          :value="Number(z3.price)"
                          @keyup="
                            validateNotNullPrice(
                              'bookWholesalePriceZone3Part' + (index + 1),
                              Number(z3.price)
                            )
                          "
                          class="form-control"
                          :name="'bookWholesalePriceZone3Part' + (index + 1)"
                          :id="'bookWholesalePriceZone3Part' + (index + 1)"
                        />
                        <div
                          :class="
                            `invalid-feedback invalidbookWholesalePriceZone3Part${index +
                              1}`
                          "
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade show"
            id="grosirZone4"
            role="tabpanel"
            aria-labelledby="grosirZone5-tab"
          >
            <div class="row">
              <div class="col-12">
                <div
                  class="form-row"
                  v-for="(z4, index) in bookPriceGrosir.zone4"
                  :key="index"
                >
                  <div class="col-md-2">
                    <div class="form-group">
                      <div class="form-group">
                        <label>Pembelian Minimum</label>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <label class="input-group-text">Min.</label>
                          </div>
                          <input
                            min="0"
                            max="999999999999"
                            maxlength="20"
                            oninput="this.value=this.value.slice(0,this.maxLength||1/1);
                                this.value=(this.value   < 0) ? (1/1) : this.value;"
                            class="form-control"
                            type="number"
                            :value="Number(z4.min)"
                            :name="'bookMinWholesaleZone4Part' + (index + 1)"
                            :id="'bookMinWholesaleZone4Part' + (index + 1)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="form-group">
                      <label class="text-success"
                        >Harga Grosir {{ index + 1 }}</label
                      >
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <label class="input-group-text">Rp.</label>
                        </div>
                        <CurrencyInput
                          :value="Number(z4.price)"
                          class="form-control"
                          :name="'bookWholesalePriceZone4Part' + (index + 1)"
                          :id="'bookWholesalePriceZone4Part' + (index + 1)"
                          @keyup="
                            validateNotNullPrice(
                              'bookWholesalePriceZone4Part' + (index + 1),
                              Number(z4.price)
                            )
                          "
                        />
                        <div
                          :class="
                            `invalid-feedback invalidbookWholesalePriceZone4Part${index +
                              1}`
                          "
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade show"
            id="grosirZone5"
            role="tabpanel"
            aria-labelledby="grosirZone5-tab"
          >
            <div class="row">
              <div class="col-12">
                <div
                  class="form-row"
                  v-for="(z5, index) in bookPriceGrosir.zone5"
                  :key="index"
                >
                  <div class="col-md-2">
                    <div class="form-group">
                      <div class="form-group">
                        <label>Pembelian Minimum</label>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <label class="input-group-text">Min.</label>
                          </div>
                          <input
                            min="0"
                            max="999999999999"
                            maxlength="20"
                            oninput="this.value=this.value.slice(0,this.maxLength||1/1);
                                this.value=(this.value   < 0) ? (1/1) : this.value;"
                            class="form-control"
                            type="number"
                            :value="Number(z5.min)"
                            :name="'bookMinWholesaleZone5Part' + (index + 1)"
                            :id="'bookMinWholesaleZone5Part' + (index + 1)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="form-group">
                      <label class="text-success"
                        >Harga Grosir {{ index + 1 }}</label
                      >
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <label class="input-group-text">Rp.</label>
                        </div>
                        <CurrencyInput
                          :value="Number(z5.price)"
                          @keyup="
                            validateNotNullPrice(
                              'bookWholesalePriceZone5Part' + (index + 1),
                              Number(z5.price)
                            )
                          "
                          class="form-control"
                          :name="'bookWholesalePriceZone5Part' + (index + 1)"
                          :id="'bookWholesalePriceZone5Part' + (index + 1)"
                        />
                        <div
                          :class="
                            `invalid-feedback invalidbookWholesalePriceZone5Part${index +
                              1}`
                          "
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>

  <div class="card-on-card card-outline-secondary" id="priceLayout" v-else>
    <div class="card-header">
      <h5 class="mb-2 font-weight-bold">Informasi Harga</h5>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <div class="form-row mb-4 mb-4">
            <div class="col-md-6">
              <label class="col-md col-form-label">Harga Satuan </label>
              <CurrencyInput
                v-model="sectionPriceInformation.price"
                class="form-control col-md-12"
                id="productPrice"
              />
              <!-- Table ppn harga satuan-->
              <!-- <table v-if="isPpnDikenakan">
                <tr style="display: none;">
                  <td width="20%"><small> DPP </small></td>
                  <td width="2%">:</td>
                  <td><span id="dpp">Rp 4.500.000</span></td>
                </tr>
                <tr style="display: none;">
                  <td><small> PPN 11%</small></td>
                  <td>:</td>
                  <td><span id="ppn">Rp 0</span></td>
                </tr>
                <tr>
                  <td width="20%"><small> PPh 0.5%</small></td>
                  <td width="2%">:</td>
                  <td>
                    <span id="pph">{{ formatCurrency(pph) }}</span>
                  </td>
                </tr>
                <tr>
                  <td><small> Dana diterima oleh penyedia</small></td>
                  <td>:</td>
                  <td>
                    <span id="terima"> {{ formatCurrency(danaDiterima) }}</span>
                  </td>
                </tr>
              </table> -->
              <table v-if="isPpnDikenakan">
                <tr style="display: table-row;">
                  <td width="20%"><small> DPP PPH </small></td>
                  <td width="2%">:</td>
                  <td>
                    <span id="dpp">{{ formatCurrency(dpp) }}</span>
                  </td>
                </tr>
                <tr style="display: table-row;">
                  <td width="20%"><small> DPP Nilai Lain </small></td>
                  <td width="2%">:</td>
                  <td>
                    <span id="dppNilaiLainHargaSatuan">{{
                      formatCurrency(dppNilaiLain)
                    }}</span>
                  </td>
                </tr>
                <tr style="display: table-row;">
                  <td><small> PPN 12%</small></td>
                  <td>:</td>
                  <td>
                    <span id="ppn">{{ formatCurrency(ppn) }}</span>
                  </td>
                </tr>

                <tr>
                  <td width="20%"><small> PPh 0.5%</small></td>
                  <td width="2%">:</td>
                  <td>
                    <span id="pph"> {{ formatCurrency(pph) }}</span>
                  </td>
                </tr>
                <tr>
                  <td><small> *Dana diterima oleh penyedia</small></td>
                  <td>:</td>
                  <td>
                    <span id="terima"> {{ formatCurrency(danaDiterima) }}</span>
                  </td>
                </tr>
              </table>

              <!-- Table no ppn harga satuan-->
              <!-- <table v-if="!isPpnDikenakan">
                <tr style="display: none;">
                  <td width="20%"><small> DPP </small></td>
                  <td width="2%">:</td>
                  <td><span id="dpp">Rp 4.500.000</span></td>
                </tr>
                <tr style="display: none;">
                  <td><small> PPN 11%</small></td>
                  <td>:</td>
                  <td><span id="ppn">Rp 0</span></td>
                </tr>
                <tr>
                  <td width="20%"><small>Harga</small></td>
                  <td width="2%">:</td>
                  <td>
                    <span id="pph">{{
                      formatCurrency(this.sectionPriceInformation.price)
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td width="20%"><small>Keterangan</small></td>
                  <td width="2%">:</td>
                  <td>
                    <span id="pph">Bebas Pajak</span>
                  </td>
                </tr>
                <tr>
                  <td width="20%"><small>DPP Nilai Lain</small></td>
                  <td width="2%">:</td>
                  <td>
                    <span id="pph">{{
                      formatCurrency(this.sectionPriceInformation.price)
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td><small>PPN</small></td>
                  <td>:</td>
                  <td>
                    <span id="terima">{{ formatCurrency(0) }}</span>
                  </td>
                </tr>
              </table> -->
              <table v-if="!isPpnDikenakan">
                <tr style="display: table-row;">
                  <td width="20%"><small> DPP PPH </small></td>
                  <td width="2%">:</td>
                  <td>
                    <span id="dppPph">{{
                      formatCurrency(this.sectionPriceInformation.price)
                    }}</span>
                  </td>
                </tr>
                <tr style="display: table-row;">
                  <td width="20%"><small> DPP Nilai Lain </small></td>
                  <td width="2%">:</td>
                  <td>
                    <span id="dppNilaiLainHargaSatuan">{{
                      formatCurrency(0)
                    }}</span>
                  </td>
                </tr>
                <tr style="display: table-row;">
                  <td><small> PPN 12%</small></td>
                  <td>:</td>
                  <td>
                    {{ formatCurrency(0) }}
                  </td>
                </tr>

                <tr>
                  <td width="20%"><small> PPh 0.5%</small></td>
                  <td width="2%">:</td>
                  <td>
                    <span id="pph"> {{ formatCurrency(pphNoPpn) }}</span>
                  </td>
                </tr>
                <tr>
                  <td><small> *Dana diterima oleh penyedia</small></td>
                  <td>:</td>
                  <td>
                    <span id="terima">
                      {{ formatCurrency(danaDiterimaNoPpn) }}</span
                    >
                  </td>
                </tr>
              </table>
            </div>

            <div class="col-md-6">
              <label class="col-md col-form-label">Harga maks.nego </label>
              <CurrencyInput
                v-model="sectionPriceInformation.priceNego"
                class="form-control col-md-12"
                id="productNegoPrice"
              />
              <!-- Table ppn harga nego-->

              <!-- <table v-if="isPpnDikenakan">
                <tr style="display: none;">
                  <td width="20%"><small> DPP</small></td>
                  <td width="2%">:</td>
                  <td><span id="dppNego">Rp 3.000.000</span></td>
                </tr>
                <tr style="display: none;">
                  <td><small> PPN 11%</small></td>
                  <td>:</td>
                  <td><span id="ppnNego">Rp 0</span></td>
                </tr>
                <tr>
                  <td width="20%"><small> PPh 0.5%</small></td>
                  <td width="2%">:</td>
                  <td>
                    <span id="pphNego">{{ formatCurrency(pphNego) }}</span>
                  </td>
                </tr>
                <tr>
                  <td><small> Dana diterima oleh penyedia</small></td>
                  <td>:</td>
                  <td>
                    <span id="terimaNego">
                      {{ formatCurrency(danaDiterimaNego) }}</span
                    >
                  </td>
                </tr>
              </table> -->
              <table v-if="isPpnDikenakan">
                <tr style="display: table-row;">
                  <td width="20%"><small> DPP PPH</small></td>
                  <td width="2%">:</td>
                  <td>
                    <span id="dppNego">{{ formatCurrency(dppNego) }}</span>
                  </td>
                </tr>
                <tr style="display: table-row;">
                  <td width="20%"><small> DPP Nilai Lain </small></td>
                  <td width="2%">:</td>
                  <td>
                    <span id="dppNilaiLainNego">{{
                      formatCurrency(dppNilaiLainNego)
                    }}</span>
                  </td>
                </tr>
                <tr style="display: table-row;">
                  <td><small> PPN 12%</small></td>
                  <td>:</td>
                  <td>
                    <span id="ppnNego">{{ formatCurrency(ppnNego) }}</span>
                  </td>
                </tr>
                <tr>
                  <td width="20%"><small> PPh 0.5%</small></td>
                  <td width="2%">:</td>
                  <td>
                    <span id="pphNego">{{ formatCurrency(pphNego) }}</span>
                  </td>
                </tr>
                <tr>
                  <td><small> Dana diterima oleh penyedia</small></td>
                  <td>:</td>
                  <td>
                    <span id="terimaNego">{{
                      formatCurrency(danaDiterimaNego)
                    }}</span>
                  </td>
                </tr>
              </table>

              <!-- Table no ppn harga nego-->
              <!-- <table v-if="!isPpnDikenakan">
                <tr style="display: none;">
                  <td width="20%"><small> DPP </small></td>
                  <td width="2%">:</td>
                  <td><span id="dpp">Rp 4.500.000</span></td>
                </tr>
                <tr style="display: none;">
                  <td><small> PPN 11%</small></td>
                  <td>:</td>
                  <td><span id="ppn">Rp 0</span></td>
                </tr>
                <tr>
                  <td width="20%"><small>Harga</small></td>
                  <td width="2%">:</td>
                  <td>
                    <span id="pph">{{
                      formatCurrency(this.sectionPriceInformation.priceNego)
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td width="20%"><small>Keterangan</small></td>
                  <td width="2%">:</td>
                  <td>
                    <span id="pph">Bebas Pajak</span>
                  </td>
                </tr>
                <tr>
                  <td width="20%"><small>DPP Nilai Lain</small></td>
                  <td width="2%">:</td>
                  <td>
                    <span id="pph">{{
                      formatCurrency(this.sectionPriceInformation.priceNego)
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td><small>PPN</small></td>
                  <td>:</td>
                  <td>
                    <span id="terima">{{ formatCurrency(0) }}</span>
                  </td>
                </tr>
              </table> -->
              <table v-if="!isPpnDikenakan">
                <tr style="display: table-row;">
                  <td width="20%"><small> DPP PPH </small></td>
                  <td width="2%">:</td>
                  <td>
                    <span id="dppPph">{{
                      formatCurrency(this.sectionPriceInformation.priceNego)
                    }}</span>
                  </td>
                </tr>
                <tr style="display: table-row;">
                  <td width="20%"><small> DPP Nilai Lain </small></td>
                  <td width="2%">:</td>
                  <td>
                    <span id="dppNilaiLainHargaSatuan">{{
                      formatCurrency(0)
                    }}</span>
                  </td>
                </tr>
                <tr style="display: table-row;">
                  <td><small> PPN 12%</small></td>
                  <td>:</td>
                  <td>
                    {{ formatCurrency(0) }}
                  </td>
                </tr>

                <tr>
                  <td width="20%"><small> PPh 0.5%</small></td>
                  <td width="2%">:</td>
                  <td>
                    <span id="pph"> {{ formatCurrency(pphNoPpnNego) }}</span>
                  </td>
                </tr>
                <tr>
                  <td><small> *Dana diterima oleh penyedia</small></td>
                  <td>:</td>
                  <td>
                    <span id="terima">
                      {{ formatCurrency(danaDiterimaNoPpnNego) }}</span
                    >
                  </td>
                </tr>
              </table>
            </div>
            <small
              ><br />
              *Perhitungan ini adalah simulasi. Besaran dana disalurkan dapat
              berkurang apabila terdapat pemotongan biaya administrasi layanan
              dari mitra
            </small>
          </div>

          <div class="form-row mb-4 mb-4">
            <label class="col-md col-form-label">Tag PPN </label>
            <select
              name="tagPpnJasa"
              id="tagPpnJasa"
              class="form-control col-md-4 mr-2"
            >
              <!-- Menampilkan opsi default hanya jika selectedTag ada -->
              <option
                v-if="formattedSelectedTag"
                :value="selectedTag"
                selected
                disabled
              >
                {{ formattedSelectedTag }}
              </option>
              <option value="0:Dikenakan PPN"> Dikenakan PPN </option
              ><option
                value="1:Makanan dan minuman yang disajikan di hotel, restoran, rumah makan, warung, dan sejenisnya, meliputi makanan dan minuman baik yang dikonsumsi di tempat maupun tidak, termasuk makanan dan minuman yang diserahkan oleh usaha jas"
              >
                Makanan dan minuman yang disajikan di hotel, restoran, rumah
                makan, warung, dan sejenisnya, meliputi makanan dan minuman baik
                yang dikonsumsi di tempat maupun tidak, termasuk makanan dan
                minuman yang diserahkan oleh usaha jas </option
              ><option value="2:Jasa keagamaan"> Jasa keagamaan </option
              ><option
                value="3:Jasa kesenian dan hiburan, meliputi semua jenis jasa yang dilakukan oleh pekerja seni dan hiburan yang merupakan objek pajak daerah"
              >
                Jasa kesenian dan hiburan, meliputi semua jenis jasa yang
                dilakukan oleh pekerja seni dan hiburan yang merupakan objek
                pajak daerah </option
              ><option
                value="4:Jasa perhotelan, meliputi jasa penyewaan kamar dan/atau jasa penyewaan ruangan di hotel yang merupakan objek pajak daerah"
              >
                Jasa perhotelan, meliputi jasa penyewaan kamar dan/atau jasa
                penyewaan ruangan di hotel yang merupakan objek pajak daerah </option
              ><option
                value="5:Jasa yang disediakan oleh pemerintah dalam rangka menjalankan pemerintahan secara umum"
              >
                Jasa yang disediakan oleh pemerintah dalam rangka menjalankan
                pemerintahan secara umum </option
              ><option value="6:Jasa penyediaan tempat parkir">
                Jasa penyediaan tempat parkir </option
              ><option
                value="7:Pengadaan vaksin dalam rangka program vaksinasi nasional"
              >
                Pengadaan vaksin dalam rangka program vaksinasi nasional </option
              ><option
                value="8:Buku pelajaran umum, kitab suci, dan buku pelajaran agama dengan harga yang relatif terjangkau masyarakat umum, kitab suci, dan buku pelajaran agama dengan harga yang relatif terjangkau masyarakat"
              >
                Buku pelajaran umum, kitab suci, dan buku pelajaran agama dengan
                harga yang relatif terjangkau masyarakat umum, kitab suci, dan
                buku pelajaran agama dengan harga yang relatif terjangkau
                masyarakat </option
              ><option
                value="9:Barang kebutuhan pokok yang sangat dibutuhkan oleh rakyat banyak"
              >
                Barang kebutuhan pokok yang sangat dibutuhkan oleh rakyat banyak </option
              ><option value="10:Jasa keuangan"> Jasa keuangan </option
              ><option value="11:Jasa asuransi"> Jasa asuransi </option
              ><option value="12:Jasa pendidikan"> Jasa pendidikan </option
              ><option
                value="13:Jasa angkutan umum di darat dan di air serta jasa angkutan udara dalam negeri yang menjadi bagian tidak terpisahkan dari jasa angkutan luar negeri"
              >
                Jasa angkutan umum di darat dan di air serta jasa angkutan udara
                dalam negeri yang menjadi bagian tidak terpisahkan dari jasa
                angkutan luar negeri </option
              ><option value="14:Jangat dan kulit mentah yang tidak disamak">
                Jangat dan kulit mentah yang tidak disamak </option
              ><option
                value="15:Ternak yang kriteria dan/atau rinciannya diatur dengan Peraturan Menteri setelah mendapat pertimbangan dari menteri yang menyelenggarakan urusan pemerintahan di bidang pertanian"
              >
                Ternak yang kriteria dan/atau rinciannya diatur dengan Peraturan
                Menteri setelah mendapat pertimbangan dari menteri yang
                menyelenggarakan urusan pemerintahan di bidang pertanian </option
              ><option
                value="16:Bibit dan/atau benih dari barang pertanian, perkebunan, kehutanan, peternakan, atau perikanan"
              >
                Bibit dan/atau benih dari barang pertanian, perkebunan,
                kehutanan, peternakan, atau perikanan </option
              ><option
                value="17:Pakan ternak tidak termasuk pakan hewan kesayangan"
              >
                Pakan ternak tidak termasuk pakan hewan kesayangan </option
              ><option value="18:Pakan ikan"> Pakan ikan </option
              ><option
                value="19:Bahan pakan untuk pembuatan pakan ternak dan pakan ikan, tidak termasuk imbuhan pakan dan pelengkap pakan, yang kriteria dan/atau rincian bahan pakan diatur dengan Peraturan Menteri"
              >
                Bahan pakan untuk pembuatan pakan ternak dan pakan ikan, tidak
                termasuk imbuhan pakan dan pelengkap pakan, yang kriteria
                dan/atau rincian bahan pakan diatur dengan Peraturan Menteri </option
              ><option
                value="20:Bahan baku kerajinan perak dalam bentuk perak butiran dan/ atau dalam bentuk perak batangan"
              >
                Bahan baku kerajinan perak dalam bentuk perak butiran dan/ atau
                dalam bentuk perak batangan </option
              ><option
                value="21:Listrik, termasuk biaya penyambungan listrik dan biaya beban listrik, kecuali untuk rumah dengan daya di atas 6.600 (enam ribu enam ratus) Voltase/Amper"
              >
                Listrik, termasuk biaya penyambungan listrik dan biaya beban
                listrik, kecuali untuk rumah dengan daya di atas 6.600 (enam
                ribu enam ratus) Voltase/Amper </option
              ><option value="22:Liquified Natural Gas (LNG)">
                Liquified Natural Gas (LNG) </option
              ><option
                value="23:Penyerahan jasa angkutan umum oleh orang pribadi yang dilakukan melalui Pihak Lain"
              >
                Penyerahan jasa angkutan umum oleh orang pribadi yang dilakukan
                melalui Pihak Lain </option
              ><option
                value="24:Penyerahan Barang Kena Pajak dan/atau Jasa Kena Pajak yang dilakukan oleh Rekanan yang pembayarannya dilakukan melalui mekanisme Pembayaran Langsung (LS)"
              >
                Penyerahan Barang Kena Pajak dan/atau Jasa Kena Pajak yang
                dilakukan oleh Rekanan yang pembayarannya dilakukan melalui
                mekanisme Pembayaran Langsung (LS) </option
              ><option value="25:Pembayaran Honor/Narasumber">
                Pembayaran Honor/Narasumber </option
              ><option value="26:Pelatihan dan Biaya Perjalanan Dinas">
                Pelatihan dan Biaya Perjalanan Dinas
              </option></select
            >

            <label class="col-md col-form-label" v-if="isLayoutService"
              >Satuan Jasa</label
            >
            <label class="col-md col-form-label" v-else>Satuan Barang</label>
            <select
              name="productUnitType"
              class="form-control col-md-4"
              id="productUnitType"
            >
              <option
                v-for="tipe in sectionPriceInformation.unitType"
                :selected="tipe.isSelected"
                :value="tipe.value"
                :key="tipe.value"
              >
                {{ tipe.value }}
              </option>
            </select>
          </div>
        </div>
        <div :hidden="isLayoutService" class="card-header">
          <h5 class="mb-2">
            <b>Harga Grosir</b>
            <button
              class="ml-2 btn btn-info btn-circle btn-sm collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#grosirCollapse"
              aria-expanded="false"
              aria-controls="collapseExample"
            >
              <i
                class="fa fa-compress"
                style="font-size: 12px"
                aria-hidden="true"
              ></i>
            </button>
          </h5>
          <p class="grosir-info">
            Masukkan harga grosir. Harga grosir biasanya lebih murah daripada
            harga satuan. Harga grosir memiliki minimum pembelian dan harga
            bertingkat (3-4 tingkat). Barang seperti ini disebut juga barang
            Wholesale.
          </p>
        </div>
        <div
          :hidden="isLayoutService"
          class="card-body collapse"
          id="grosirCollapse"
          style=""
        >
          <div v-if="!isLayoutBook && !isLayoutService" class="row">
            <div class="col-12">
              <!-- <div
                class="form-row mb-4 mb-4"
                v-for="(pg, index) in sectionPriceInformation.priceGrosir"
                :key="pg.id"
              >
                <label class="col-md col-form-label">Pembelian Minimum </label>
                <div class="col-lg-4">
                  <input
                    class="form-control"
                    type="number"
                    :name="'grosir_min' + (index + 1)"
                    :id="'grosir_min' + (index + 1)"
                    v-model.number="pg.min"
                  />
                  <span class="help-block with-errors"></span>
                </div>
                <label class="col-md col-form-label text-success"
                  >@ Harga Grosir
                </label>
                <div class="col-lg-6">
                  <input
                    type="number"
                    :name="'grosir_price' + (index + 1)"
                    :id="'grosir_price' + (index + 1)"
                    class="form-control"
                    v-model.number="pg.price"
                  /><span class="help-block with-errors"></span>
                  <p id="invalidGrosir1" class="text-red "></p>
                  <table>
                    <tr>
                      <td width="20%"><small>PPh 0.5% </small></td>
                      <td width="2%">:</td>
                      <td>
                        <span :id="'pphGrosir' + (index + 1)">
                          {{ formatCurrency(pphGrosir[index]) }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td><small>Dana diterima oleh penyedia</small></td>
                      <td>:</td>
                      <td>
                        <span
                          :id="'terimaGrosir' + (index + 1)"
                          v-text="
                            pg.min > 0
                              ? formatCurrency(danaDiterimaGrosir[index])
                              : 'Rp 0'
                          "
                        ></span>
                      </td>
                    </tr>
                  </table>
                </div>
              </div> -->

              <div
                class="form-row mb-4 mb-4"
                v-for="(pg, index) in sectionPriceInformation.priceGrosir"
                :key="pg.id"
              >
                <div class="col-md-2">
                  <div class="form-group">
                    <label>Pembelian Minimum</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <label class="input-group-text">Min.</label>
                      </div>
                      <input
                        min="0"
                        max="999999999999"
                        maxlength="20"
                        onkeyup="this.value=this.value.slice(0,this.maxLength||1/1);
            this.value=(this.value < 0) ? (1/1) : this.value;"
                        class="form-control"
                        type="number"
                        :name="'grosir_min' + (index + 1)"
                        :id="'grosir_min' + (index + 1)"
                        v-model.number="pg.min"
                        @keyup="validateNotNull('grosir_min' + (index + 1))"
                      />
                    </div>
                    <span class="help-block with-errors"></span>
                  </div>
                </div>

                <div class="col-md">
                  <div class="form-group">
                    <label class="text-success">@Harga Grosir</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <label class="input-group-text">Rp.</label>
                      </div>
                      <CurrencyInput
                        max="999999999999"
                        maxlength="20"
                        v-model.number="pg.price"
                        :name="'grosir_price' + (index + 1)"
                        :id="'grosir_price' + (index + 1)"
                        :disabled="pg.min <= 0"
                        @keyup="validateNotNull('grosir_price' + (index + 1))"
                        class="form-control"
                      />
                    </div>
                    <div v-if="pg.min <= 0" class="invalid-feedback">
                      Masukan jumlah pembelian minimum terlebih dahulu
                    </div>

                    <!-- ppn grosir -->
                    <table v-if="isPpnDikenakan">
                      <tr>
                        <td width="20%"><small>DPP PPH</small></td>
                        <td width="2%">:</td>
                        <td>
                          <span :id="'dppGrosir' + (index + 1)">
                            {{ formatCurrency(dppGrosir[index]) }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td width="20%"><small>DPP Nilai Lain</small></td>
                        <td width="2%">:</td>
                        <td>
                          <span :id="'dppNilaiLainGrosir' + (index + 1)">
                            {{ formatCurrency(dppNilaiLainGrosir[index]) }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td><small>PPN 12%</small></td>
                        <td>:</td>
                        <td>
                          <span :id="'ppnGrosir' + (index + 1)">
                            {{ formatCurrency(ppnGrosir[index]) }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td><small>PPh 0.5%</small></td>
                        <td>:</td>
                        <td>
                          <span :id="'pphGrosir' + (index + 1)">
                            {{ formatCurrency(pphGrosir[index]) }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td><small>Dana diterima oleh penyedia</small></td>
                        <td>:</td>
                        <td>
                          <span :id="'danaDiterimaGrosir' + (index + 1)">
                            {{ formatCurrency(danaDiterimaGrosir[index]) }}
                          </span>
                        </td>
                      </tr>
                    </table>

                    <!-- no ppn grosir -->
                    <table v-else>
                      <tr>
                        <td width="20%"><small>DPP PPH</small></td>
                        <td width="2%">:</td>
                        <td>
                          <span :id="'dppGrosir' + (index + 1)">
                            {{ formatCurrency(pg.price) }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td width="20%"><small>DPP Nilai Lain</small></td>
                        <td width="2%">:</td>
                        <td>
                          <span :id="'dppNilaiLainGrosir' + (index + 1)">
                            {{ formatCurrency(0) }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td><small>PPN 12%</small></td>
                        <td>:</td>
                        <td>{{ formatCurrency(0) }}</td>
                      </tr>
                      <tr>
                        <td><small>PPh 0.5%</small></td>
                        <td>:</td>
                        <td>
                          <span :id="'pphGrosir' + (index + 1)">
                            {{ formatCurrency(pg.price * 0.005) }}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td><small>Dana diterima oleh penyedia</small></td>
                        <td>:</td>
                        <td>
                          <span :id="'danaDiterimaGrosir' + (index + 1)">
                            {{ formatCurrency(pg.price - pg.price * 0.005) }}
                          </span>
                        </td>
                      </tr>
                    </table>

                    <small>
                      *Perhitungan ini adalah simulasi. Besaran dana disalurkan
                      dapat berkurang apabila terdapat pemotongan biaya
                      administrasi layanan dari mitra
                    </small>
                    <br />
                    <small>
                      *PPN yang dikenakan telah menggunakan perhitungan terbaru
                      sesuai dengan PMK No. 131 Tahun 2024
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Paket -->
    <div class="card-body">
      <div class="card-header mb-3">
        <h5 class="mb-2">
          <b>Isi Paket</b>
        </h5>
        <p class="grosir-info">
          Isi paket berdasarkan produk yang sudah di input sebelumnya
        </p>

        <div class="col-md-12"></div>

        <div class="row">
          <div class="col-md-10">
            <input
              type="text"
              v-model="findPaket"
              class="form-control"
              placeholder="Cari nama produk yang ada di toko anda"
            />
          </div>
          <div class="col-md-2" style="margin-top: -9px; margin-left: -32px">
            <button class="btn btn-primary" type="button">Cari</button>
          </div>
          <div class="col-md-12">
            <table
              class="table table-condensed text-center table-hover"
              width="100%"
            >
              <tbody>
                <tr v-for="(dp, index) in paketData" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>
                    <img
                      :src="
                        'https://cdn.eurekabookhouse.co.id/ebh/product/all/' +
                          dp.image
                      "
                      class="img-responsive"
                      height="50px"
                      alt=""
                    />
                  </td>
                  <td>{{ dp.name }}</td>
                  <td>
                    <input
                      type="number"
                      min="0"
                      :id="'inputPaketQty' + (index + 1)"
                      class="form-control"
                      placeholder="Masukan Jumlah Quantity"
                    />
                  </td>
                  <td>
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="
                        addPaket(dp.product_id, `#inputPaketQty${index + 1}`)
                      "
                    >
                      Tambah
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <table
              class="table table-condensed text-center table-hover"
              width="100%"
            >
              <thead>
                <tr
                  class="
                        table-condensed
                        text-uppercase text-muted text-sm-center
                      "
                >
                  <th>No</th>
                  <th>Cover</th>
                  <th>Name</th>
                  <th>Price</th>
                  <th>Qty</th>
                  <th>Aksi</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(pd, index) in dataPaket" :key="index">
                  <td>{{ index + 1 }}</td>
                  <th scope="row">
                    <img
                      :src="
                        'https://cdn.eurekabookhouse.co.id/ebh/product/all/' +
                          pd.image
                      "
                      class="img-responsive"
                      height="50px"
                      alt=""
                    />
                  </th>
                  <td>{{ pd.name }}<br /></td>
                  <td>{{ pd.price }}</td>
                  <td>
                    {{ pd.quantity }}
                  </td>

                  <td>
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="deletePaket(pd.packet_did)"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import axios from "axios";
import $ from "jquery";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      bookPriceGrosir: [],
      isNonText: false,
      grosirPrice: 0,
      selectedTag: "",
      dataPaket: [], //dataPaket untuk menampuk data paket yang dimiliki user
      paketData: [], //PaketData untuk menampung data packet ketika mencari
      findPaket: "",
      debounceTimer: null,
      tagValue: null,
    };
  },
  props: {
    sectionProductInformation: {},
    isChecked: Boolean,
    isLayoutBook: Boolean,
    sectionPriceInformation: Object,
    grosirAutoCorrectPrice: Function,
    isLayoutService: Boolean,
    currentTag: String,
    listppntag: Array,
  },

  watch: {
    currentTag: {
      immediate: true, // Agar langsung dijalankan saat komponen di-mount
      handler(newValue) {
        this.selectedTag = newValue || "";
      },
    },

    findPaket(newVal) {
      // Jika input kosong, reset data dan hentikan request
      if (!newVal.trim()) {
        this.paketData = [];
        clearTimeout(this.debounceTimer);
        return;
      }

      // Debounce: Hapus timer sebelumnya jika ada
      clearTimeout(this.debounceTimer);

      // Set timer baru untuk delay request API
      this.debounceTimer = setTimeout(() => {
        this.findProductPacket();
      }, 500);
    },
  },

  created() {
    this.getPaket();
  },
  mounted() {
    $(".toggle_table").bootstrapToggle();
    // console.log(this.sectionPriceInformation)

    this.updateTagValue();
    $(document).on("change", "#tagPpnJasa", this.updateTagValue);
  },
  updated() {
    this.isNonText = this.bookPriceGrosir = this.sectionPriceInformation.priceGrosir;
  },
  computed: {
    // Harga Satuan
    dpp() {
      return this.floorExcelLike(this.sectionPriceInformation.price / 1.11);
    },
    dppNilaiLain() {
      return this.floorExcelLike(
        (11 / 12) * (this.sectionPriceInformation.price / 1.11)
      );
    },
    ppn() {
      return Math.ceil(
        (this.sectionPriceInformation.price / 1.11) * (11 / 12) * 0.12
      );
    },
    pph() {
      return this.floorExcelLike(
        (this.sectionPriceInformation.price / 1.11) * 0.005
      );
    },
    pphNoPpn() {
      return Math.floor(this.sectionPriceInformation.price * 0.005);
    },

    danaDiterima() {
      return this.sectionPriceInformation.price - this.ppn - this.pph;
    },

    danaDiterimaNoPpn() {
      return this.sectionPriceInformation.price - this.pph;
    },

    // Nego
    dppNego() {
      console.log(this.tagValue);
      return this.floorExcelLike(this.sectionPriceInformation.priceNego / 1.11);
    },
    dppNilaiLainNego() {
      return this.floorExcelLike(
        (11 / 12) * (this.sectionPriceInformation.priceNego / 1.11)
      );
    },
    ppnNego() {
      return Math.ceil(
        (this.sectionPriceInformation.priceNego / 1.11) * (11 / 12) * 0.12
      );
    },

    pphNego() {
      return Math.floor(this.dppNego * 0.005);
    },

    pphNoPpnNego() {
      return Math.floor(this.sectionPriceInformation.priceNego * 0.005);
    },

    danaDiterimaNego() {
      return (
        this.sectionPriceInformation.priceNego - this.ppnNego - this.pphNego
      );
    },

    danaDiterimaNoPpnNego() {
      return this.sectionPriceInformation.priceNego - this.pphNoPpnNego;
    },

    // Grosir
    dppGrosir() {
      return this.sectionPriceInformation.priceGrosir.map((pg) => {
        console.log(pg);
        const price = Number(pg.price) || 0;

        const dppPerUnit = this.floorExcelLike(price / 1.11); // rumus sudah benar
        return dppPerUnit;
      });
    },
    dppNilaiLainGrosir() {
      return this.sectionPriceInformation.priceGrosir.map((pg) => {
        const price = Number(pg.price) || 0;

        if (price === 0) return 0;

        const dppPerUnit = (11 / 12) * (price / 1.11); // Jangan dibulatkan dulu
        return this.floorExcelLike(dppPerUnit); // Bulatkan hasil akhir
      });
    },

    ppnGrosir() {
      return this.sectionPriceInformation.priceGrosir.map((pg) => {
        const price = Number(pg.price) || 0;

        if (price === 0) return 0;

        const ppnPerUnit = (price / 1.11) * (11 / 12) * 0.12;
        return Math.ceil(ppnPerUnit);
      });
    },
    pphGrosir() {
      return this.sectionPriceInformation.priceGrosir.map((pg, index) => {
        return Math.floor(this.dppGrosir[index] * 0.005);
      });
    },
    danaDiterimaGrosir() {
      return this.sectionPriceInformation.priceGrosir.map((pg, index) => {
        const price = Number(pg.price) || 0;

        const nettoPerUnit =
          price - this.ppnGrosir[index] - this.pphGrosir[index];
        return nettoPerUnit;
      });
    },

    // pphGrosir() {
    //   return this.sectionPriceInformation.priceGrosir.map((pg) => {
    //     const price = Number(pg.price) || 0;
    //     // const min = Number(pg.min) || 0;
    //     return price * 0.005;
    //   });
    // },

    // danaDiterimaGrosir() {
    //   return this.sectionPriceInformation.priceGrosir.map(
    //     (pg, index) => Number(pg.price) - this.pphGrosir[index]
    //     // return this.sectionPriceInformation.priceGrosir.map(
    //     //   (pg, index) => Number(pg.price) * Number(pg.min) - this.pphGrosir[index]
    //   );
    // },

    danaDiterimaNoPpnGrosir() {
      return this.hargaGrosir.map((pg) => {
        const price = Number(pg) || 0;
        return this.nonBookUnitPrice - price * 0.005;
      });
    },

    isPpnDikenakan() {
      if (!this.tagValue) {
        const firstPart = this.selectedTag.split(":")[0];
        return String(firstPart) === "0";
      }

      const firstPart = this.tagValue.split(":")[0];
      return String(firstPart) === "0";
    },

    formattedSelectedTag() {
      return this.selectedTag.includes(":")
        ? this.selectedTag.split(":")[1].trim()
        : this.selectedTag;
    },

    ...mapGetters({
      isLoggedIn: "isLoggedIn",
      user: "user",
    }),
  },
  methods: {
    // floorExcelLike(number) {
    //   const rounded = Math.round((number + Number.EPSILON) * 100) / 100;
    //   return Math.floor(rounded);
    // },
    floorExcelLike(number) {
      const sen = Math.floor(number * 100);
      return Math.floor(sen / 100);
    },
    updateTagValue() {
      let val = $("#tagPpnJasa")
        .val()
        ?.trim();
      if (!val) {
        val = this.selectedTag; // Gunakan default value
      }
      this.tagValue = val;
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
      }).format(value);
    },
    validateNotNullPrice(idEl, price) {
      let element = $(`#${idEl}`);

      if (element.val().includes("-")) {
        $(`#${idEl}`).val(price);
      }

      if (element.val() === "") {
        element.addClass("is-invalid");
      } else {
        element.removeClass("is-invalid");
      }
    },
    validateNotNull(idEl) {
      let element = $(`#${idEl}`);

      if (element.val().includes("-")) {
        $(`#${idEl}`).val(0);
      }

      if (element.val() === "") {
        element.addClass("is-invalid");
      } else {
        element.removeClass("is-invalid");
      }
    },
    autoCorrectPrice(numberZone, maxNumberZone) {
      let zoneDef = $(`#${numberZone}`).val();
      let maxZone = $(`#${maxNumberZone}`).val();
      let splitedZone = Number(zoneDef.split(".").join(""));
      let splitedMaxZone = Number(maxZone.split(".").join(""));

      if (splitedZone > splitedMaxZone) {
        $(`.invalid${numberZone}`).text(
          `Harga tidak boleh melewati harga maksimal ${numberZone} (Rp${maxZone})`
        );
        $(`#${numberZone}`).addClass("is-invalid");
        // $(`#${numberZone}`).val(splitedMaxZone)
        // this.$swal.fire({
        //   title:`<span style='font-size:17px'>Harga tidak boleh melewati harga maksimal ${numberZone} (Rp${maxZone})</span>`,
        //   icon:'warning'
        // }).then(() => {
        //   $(`#${numberZone}`).val(maxZone)
        // })
      } else if (zoneDef.includes("-")) {
        $(`#${numberZone}`).val(0);
      } else {
        $(`#${numberZone}`).removeClass("is-invalid");
      }

      if (splitedZone.toString() < 1) {
        $(`.invalid${numberZone}`).text(`Harga tidak boleh kosong`);
        $(`#${numberZone}`).addClass("is-invalid");
        // $(`#${numberZone}`).val()
        // this.$swal.fire({
        //   title:`<span style='font-size:17px'>Harga tidak boleh kosong</span>`,
        //   icon:'warning'
        // })
      }
    },

    getPaket() {
      let paket = "backendseller/paket/paket_api/tempPacket/" + this.user.id;
      axios.get(paket).then((response) => {
        this.dataPaket = response.data;
        console.log(this.dataPaket, "fetch dalem");
        return;
      });
    },

    findProductPacket() {
      fetch(
        `https://siplah.eurekabookhouse.co.id/staging/backendseller/paket/paket_api/cariProduk?cari=${this.findPaket}&mall_id=${this.user.id}`
      )
        .then((response) => response.json())
        .then((data) => {
          this.paketData = data;
        });
    },

    addPaket(idProd, elem) {
      var $this = $(elem);
      var val = $this.val();
      if (val == "") {
        console.log("no input");
      } else {
        console.log(val);
      }
      // console.log(idProd,)
      let qtyVal = $(`${elem}`).val();
      if (qtyVal === 0 || qtyVal === "") {
        this.$toast.error(`Masukan Jumlah Quantity Paket`);
      } else {
        // let qtyVal = 1
        var formdata = new FormData();
        formdata.append("product_id", idProd);
        formdata.append("qty", qtyVal);
        formdata.append("mall_id", this.user.id);

        var requestOptions = {
          method: "POST",
          body: formdata,
          redirect: "follow",
        };

        fetch(
          "https://siplah.eurekabookhouse.co.id/staging/backendseller/paket/paket_api/addPacket",
          requestOptions
        ).then(() => {
          // console.log(data);
          setTimeout(() => {
            this.paketData = [];
            this.getPaket();
          }, 300);
        });
      }
    },
    deletePaket(paketId) {
      // console.log(paketId)
      fetch(
        `https://siplah.eurekabookhouse.co.id/staging/backendseller/paket/paket_api/delPacket/${paketId}`
      )
        .then((response) => response.json())
        .then(() => {
          // console.log(data);
          this.getPaket();
        });
    },
  },
};
</script>
